module.exports = __webpack_public_path__ + "static/media/memory_layout.679ffc45.png";